module.exports = __webpack_public_path__ + "img/fi-rr-upload.cd1d9035.svg";